import Resource from '@/api/Resource';
import Lesson from '@/models/Lesson';

export default class Category extends Resource {
  $name = 'categories';

  $defaults() {
    return {
      id: null,
      name: '',
    };
  }

  $fill({ lessons }) {
    if (lessons) {
      this.lessons = Lesson.collection(lessons);
    }
  }
}
